import { createStore } from "../../../../utils/createStore.ts";

export const debugModeStore = createStore(
  {
    isDebugModeOn: false,
  },
  ({ set }) => ({
    setIsDebugMode: (isDebugModeOn: boolean) => set({ isDebugModeOn }),
  }),
);
